module.exports = __webpack_public_path__ + "static/media/Project-vietnam.5a45a81e.svg";